export const ROOM_SIZE = 4;
export const DEFAULT_MAX_TRAVELERS = 8;
export const DEFAULT_MAX_ROOMS = 4;
export const CHILDREN_AGE_ERROR_MESSAGE = "Please enter children's ages to get the best price for your group";
export const INTERNATIONAL_LAP_INFANT_ERROR_MESSAGE = 'Sorry, Priceline does not offer lap infant seating on international flights';
export const WHITE_LABEL_INTERNATIONAL_LAP_INFANT_ERROR_MESSAGE = 'Sorry, we do not offer lap infant seating on international flights';